module.exports = "<template>\n    <span if.bind=\"participant.sumItemsPrice\">${ participant.sumItemsPrice | currency }</span>\n</template>\n";